/* jslint esversion: 6 */
/**
 * Menu Focus Aria
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
  menuItems: $('.menu-item-has-children'),
};

function init() {
  events();
}

function events() {

  s.menuItems.on('focusin focusout', function() {
    toggleARIAExpanded($(this));
  });
}

function toggleARIAExpanded($element) {

  if ($element.attr('aria-expanded') === 'true') {
    $element.attr('aria-expanded', 'false');
  }
  else {
    $element.attr('aria-expanded', 'true');
  }
}

export {init as default};
